import {Component, EventEmitter, Inject, OnInit, QueryList, ViewChildren} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {EstudioService} from '../estudio.service';
import {MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Meta} from '../../../_models/meta';
import {CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import {environment} from '../../../../environments/environment';
import {AuthenticationService} from '../../../_services';
import { GlobalService } from 'src/app/_services/global.service';
import { CkeditorImageDeleteDirective } from 'src/app/_directives/ckeditor-image-delete/ckeditor-image-delete.directive';

const API_URL = environment.apiUrl;

@Component({
  selector: 'meta-rapida-form',
  standalone: false,
  templateUrl: 'meta-rapida-form.component.html',
  styleUrls: ['../unidad-etapas/unidad-etapas-generales.scss','meta-form-component.scss']
})

export class MetaRapidaFormComponent implements OnInit {

  meta: Meta;

  displayLang = 'es';
  html = {
    es: '',
    en: '',
    fr: ''
  };

  tipoMeta;
  tiposMeta: any[] = [];

  guardando = false;

  descripcionForm = this.fb.group({
    es: [''],
    en: [''],
    fr: [''],
  });

  ckeditorImageEndPoint = `${API_URL}/api/storage/uploadimg`;
  refreshUrl = `${API_URL}/api/jwt/refresh`;
  userToken;
  refreshToken;

  idiomas: string[];

  onSave = new EventEmitter();

  @ViewChildren(CkeditorImageDeleteDirective) deleteImageDirectives: QueryList<CkeditorImageDeleteDirective>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private fb: UntypedFormBuilder,
              private estudioService: EstudioService,
              private customAlertService: CustomAlertService,
              private authService: AuthenticationService,
              private globalService: GlobalService) {
    this.userToken = authService.currentUserValue.token;
    this.refreshToken = authService.currentUserValue.refresh;
  }

  ngOnInit() {
    let cursos = [],
      materias = [];
    this.data.mcps.map(mcp => {
      if (cursos.filter(cur => cur.id == mcp.cursoParentID).length == 0) {
        cursos.push({id: mcp.cursoParentID});
      }
      if (materias.filter(mat => mat.id == mcp.materiaID).length == 0) {
        materias.push({id: mcp.materiaID});
      }
    });

    this.globalService.idiomas$.subscribe(res => this.idiomas = res.map(item => item.value));

    this.tiposMeta = this.data.categorias.categorias;

    this.meta = new Meta({id: 0, cursos: cursos, materias: materias, editores: this.data.editores});

    this.tipoMeta = new UntypedFormControl('', Validators.required);
  }

  guardar() {
    this.meta.categoriaID = this.tipoMeta.value;
    this.meta.categoria = {id: this.tipoMeta.value};
    this.meta.htmlES = this.descripcionForm.get('es').value;
    this.meta.htmlEN = this.descripcionForm.get('en').value;
    this.meta.htmlFR = this.descripcionForm.get('fr').value;
    this.guardando = true;
    this.estudioService.crearMeta(this.meta).subscribe(resp => {
      this.deleteImageDirectives.forEach(item => item.reset());
      let nuevaMeta = new Meta(resp);
      this.estudioService.actualizarLista(nuevaMeta, 'meta');
      this.onSave.emit();
    }, err => {
      this.guardando = false;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
      })
    });
  }
}
